<template>
  <div class="page">
    <img src="@/image/mian.png" alt="" style="width: 100%; image-rendering: -webkit-optimize-contrast;">
  </div>
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup } from 'vant';
import { Shares } from '@/js/share'
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
  },
  data() {
    return {
      isShowTopFixed: true,
      sctimer: null,
      sctopInfo: {
        sctop: 0,
        lastSctop: 0,
        distance: 80,
      },
      hideScale: '',
    }
  },
  watch: {
  },
  mounted() {
    window.addEventListener('scroll', this.scrollSet);

    let imgurl = 'https://xztys.goldweb.cn/img/shareImg1.jpg'
    let title = 'MA开辟集团数智化发展新路径'
    let desc = '统一编码标准、统一数据平台、专属AI智能体、物资管控、双碳管理、“四重”防控、产融协同'
    let link = 'https://xztys.goldweb.cn/#/home'
    // console.log(imgurl, title, desc, link)
    Shares.shareCode(imgurl, title, desc, link, (status,data) => {
      if(status === 'success') {
        console.log('success')// 分享成功的操作
      } else if(status === 'cancel') {
        console.log('error')// 分享失败的操作
      }
    })
  },
  methods: {
    scrollSet() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.$set(this.sctopInfo, 'sctop', scrollTop)
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollSet)
  }
};
</script>

<style lang="less" scoped>
.page{
  width: 375px;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #e8dcc9;
  background-size: 100% auto;
  background-attachment: fixed;
  position: relative;
}
</style>
